import axiosApiClient from '@/axios';
import { defineStore } from 'pinia';
import { ref } from 'vue';
export const useUserStore = defineStore(
  'user',
  () => {
    const user = ref({
      id: null,
      name: null,
      email: null,
      role: null,
      token: null,
      ly: 10,
      mobile: null,
      city: null,
    });

    const setUser = (u: any) => {
      user.value = u;
      localStorage.setItem('user', JSON.stringify(u));
    };

    const getUser = async () => {
      //get from localstorage if exists
      const userLocalStorage = localStorage.getItem('user');
      if (
        userLocalStorage &&
        userLocalStorage !== 'undefined' &&
        userLocalStorage !== 'null'
      ) {
        user.value = JSON.parse(userLocalStorage);
      } else {
        //await fetchUser();
        user.value = {
          id: null,
          name: null,
          email: null,
          role: null,
          token: null,
          ly: 10,
          mobile: null,
          city: null,
        };
      }
      return user.value;
    };
    const fetchUser = async () => {
      const res = await axiosApiClient.get('/user');
      if (res.status === 200) {
        user.value = res.data;
        localStorage.setItem('user', JSON.stringify(res.data));
      } else {
        user.value = {
          id: null,
          name: null,
          email: null,
          role: null,
          token: null,
          ly: 10,
          mobile: null,
          city: null,
        };
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('calculatorCart');
      }
      return user.value;
    };
    const getRole = async (id: number) => {
      const res = await axiosApiClient.get(`/api/roles/${id}`);
      if (res.status === 200) {
        return res.data.role || null;
      } else {
        return null;
      }
    };

    const logout = async () => {
      try {
        const res = await axiosApiClient.get('/user');
        if (res.status === 200) {
          await axiosApiClient.post('/logout');
          user.value = {
            id: null,
            name: null,
            email: null,
            role: null,
            token: null,
            ly: 10,
            mobile: null,
            city: null,
          };
          localStorage.removeItem('user');
          localStorage.removeItem('token');
          localStorage.removeItem('calculatorCart');
        }
      } catch (error) {
        console.error('Logout error:', error);
      }
    };

    return {
      user,
      setUser,
      getUser,
      logout,
      fetchUser,
      getRole,
    };
  },
  // ,
  // {
  //     persist: {
  //         storage: localStorage,
  //     }

  // }
);
